export default __webpack_public_path__ + "static/media/ShowMore.059cc39c.svg";